<template>
    <div>
        <h2>Social Feed</h2>
        <h3>Top Tweets</h3>
        <v-content style="max-height: 70vh" id="scroll-target" class="overflow-y-auto overflow-x-hidden">
            <v-row v-scroll align="center" justify="center">
                <v-col cols="12" :key="tweet" v-for="tweet in Tweets">
                    <v-card class="mx-auto" color="#26c6da" outlined @click="seeMore">
                        <v-card-title>
                            <v-icon medium left>mdi-twitter</v-icon>
                        </v-card-title>

                        <v-card-text>
                            <p>"{{ tweet.tweet }}"</p>
                        </v-card-text>

                        <v-card-actions>
                            <v-list-item>
                                <v-list-item-avatar color="grey darken-3">
                                    <v-img :src="tweet.userImage"></v-img>
                                </v-list-item-avatar>

                                <v-list-item-content>
                                    <v-list-item-title>@{{ tweet.user }}</v-list-item-title>
                                </v-list-item-content>

                                <v-row align="center" justify="end">
                                    <v-icon small class="mr-1">mdi-heart</v-icon>
                                    <span class="subheading mr-2">{{ tweet.likes }}</span>
                                    <v-icon small class="mr-1">mdi-share-variant</v-icon>
                                    <span class="subheading">{{ tweet.retweets }}</span>
                                </v-row>
                            </v-list-item>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </v-content>

        <button>View more tweets</button>
    </div>
</template>

<script>
    export default {
        name: "SocialFeed",
        created(){
          this.prettyNumbers();
        },
        props: {
            Tweets: Array
        },
        methods: {
            prettyNumbers(){
                this.Tweets.forEach((tweet) => {
                    if(tweet.likes > 1000)
                        tweet.likes = `${(tweet.likes / 1000).toFixed(1)} K`;
                    if(tweet.retweets > 1000)
                        tweet.retweets = `${(tweet.retweets / 1000).toFixed(1)} K`;
                });
            },
            seeMore() {

            },
        }
    }
</script>

<style lang="scss" scoped>
@import "../../../global";
</style>
